'use strict';

import 'angular';

import autofocusDirective from './autofocus';
import typeDirective from './type';
import closestDateDirective from './closest-date';

const MODULE_NAME = 'brg.components.inputs';

var app = angular.module(MODULE_NAME, []);
app.directive('autofocus', autofocusDirective);
app.directive('type', typeDirective);
app.directive('brgDateBefore', closestDateDirective(true));
app.directive('brgDateAfter', closestDateDirective(false));

export default MODULE_NAME;
